'use strict'

import $ from 'jQuery';
import Easing from '../lib/easing';
import booklet from '../lib/booklet';

let self;

export default self = {
    container: document.querySelector('#guide-book'),

    init : () => {
        $('#guide-book').booklet({
            width: '80%',
            pagePadding: 0,
            pageNumbers: false,
            shadows: false,
            manual: false,
            overlays:true,
            hovers: false,
            arrows: true,
            create: function(event, data){
                const height = document.querySelector('#guide-book img').clientHeight;
                $('#guide-book').booklet('option', 'height', height);
            }
        });

        if(window.innerWidth < 769) {
            $('#guide-book').booklet('option', 'width', '100%');
            const height = document.querySelector('#guide-book img').clientHeight;
            $('#guide-book').booklet('option', 'height', height);
        }

        window.addEventListener("resize", ()=>{
            if(window.innerWidth < 769) {
                $('#guide-book').booklet('option', 'width', '100%');
            }
            const height = document.querySelector('#guide-book img').clientHeight;
            $('#guide-book').booklet('option', 'height', height);

        });




    }
}
